import { PrescriptionPadStep } from '@/components/PatientPageV2/components/PrescriptionPad';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const advancePrescriptionPadStep: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  () => PrescriptionPadStep | null
> = (_set, get) => () => {
  const {
    prescriptionPad: { step, showCancellation },
    prescriptionHistory: { itemsToAction, itemsToCancel }
  } = get().prescriptionAssistant;
  const shouldShowCancelModal = itemsToCancel.length > 0 && itemsToAction.length === 0 && !showCancellation;

  if (step === PrescriptionPadStep.Create) {
    if (shouldShowCancelModal) {
      get().updateShowCancellation(true);
      return PrescriptionPadStep.Create;
    }

    get().updatePrescriptionPadStep(PrescriptionPadStep.Confirm);
    return PrescriptionPadStep.Confirm;
  }

  return null;
};
